<p-multiSelect [options]="callQueues" optionValue="code" [(ngModel)]="selectedCallQueues" [overlayVisible]="true" optionLabel="name" placeholder="Select Call Queues" required> </p-multiSelect>
<div class="flex flex-column justify-content-end align-items-end">
    <button [loading]="loading" (click)="onSubmit()" pButton pRipple label="Save" icon="pi pi-check" class="p-button-text mt-2"></button>
</div>
